import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "../../configureStore";

const selectUsersState = (state: RootState) => state.users;

const selectUsers = createDraftSafeSelector(
  selectUsersState,
  state => state.users
);
const selectPageSize = createDraftSafeSelector(
  selectUsersState,
  state => state.pageSize
);

const selectTotal = createDraftSafeSelector(
  selectUsersState,
  state => state.total
);

const selectCurrentPage = createDraftSafeSelector(
  selectUsersState,
  state => state.page
);

export {
  selectUsersState,
  selectUsers,
  selectPageSize,
  selectTotal,
  selectCurrentPage,
};
